// @flow
import React, { Component } from "react";
import { connect } from "react-redux";

import Properties from "../../Properties.js";
import { cropImageToFace, faceCentreFromEyes, radiusFromEyes, distanceBetweenEyes } from "../../global/functions/CropImageToFace";
import { getCookie } from "../../global/functions/cookies";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

type TileItemStatesType = {
  anchorEl: EventTarget | null
};

class TileItem extends Component<*, TileItemStatesType> {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  googleSearch = (keyword: string): * => {
    window.open("https://www.google.com.au/search?q=" + keyword);
  }

  imageSelect = (e: Event, face: Object) => {
    //this.props.setFace([face]);
    this.setState({ anchorEl: e.target });
  }

  imageUnselect = () => {
    //this.props.setFace([]);
    this.setState({ anchorEl: null });
  }

  render(): * {
    const anchorEl = this.state.anchorEl;
    const open = !!anchorEl;
    const tile = this.props.tile;
    let personFound: boolean = (tile && tile.search_results.length > 0);
    const eyes = tile && tile.eyes;

    let img;
    let person;
    let WrapColor;
    let probability;
    const accessToken = getCookie("access_token");
    const rules = { High: 90, Medium: 80, Low: 50 };
    const face = eyes && { "eyes": eyes, "centre": faceCentreFromEyes(eyes), "radius": radiusFromEyes(eyes) };
    if (personFound) {
      person = tile.search_results[0].person;
      img = `${Properties.api_root}/api/v2/conferences/${this.props.db.conference.id}/people/${accessToken}/enrolments/${tile.search_results[0].enrolment_id}/image`;
      probability = tile.search_results[0].probability * 100;
      if(probability > rules.High){
        WrapColor = "top-label";
      }
      else if (probability <= rules.High && probability > rules.Medium) {
        WrapColor = "second-label";
      }
      else if (probability <= rules.Medium && probability > rules.Low){
        WrapColor = "third-label";
      }
      else {
        personFound = false;
        img = "/images/person_place.svg";
        person = null;
        WrapColor = "no-match-label";
      }
    }
    else {
      img = "/images/person_place.svg";
      person = null;
      WrapColor = "no-match-label";
    }
    const cropImage = face && cropImageToFace(this.props.img, face).src;

    return (
      <div>
        <GridListTile className="grid-block" >
          <img src={img} className="grid-img" onClick={(e: Event) => this.imageSelect(e, face)} />
          <GridListTileBar
            title={personFound ? person.first_name + " " + person.last_name : "No Match"}
            subtitle={personFound ? <span>{person.organisation}</span> : null}
            classes={{
              title: "text-normal",
              subtitle: "text-normal",
              titleWrap: "left-margin-5 right-margin-5",
              root: WrapColor
            }}
            actionIcon={personFound ? <Typography variant="caption" gutterBottom noWrap className="white-title right-margin-5">{(tile.search_results[0].probability * 100).toFixed(2) + "%"}</Typography> : null}
          />
        </GridListTile>
        {tile &&
          <Popover
            open={open}
            anchorEl={anchorEl}
            anchorReference="anchorEl"
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={this.imageUnselect}
          >
            <Card>
              <CardContent>
                <img src={cropImage} className="card-img" />
              </CardContent>
            </Card>
          </Popover>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

export default connect(mapStateToProps)(TileItem);


// WEBPACK FOOTER //
// ./src/conference/component/TileItem.js